import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { BannerPosition, BannerPositionsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class BannerPositionsDataService {

  private uri: string = `${environment.apiUrl}banner-positions`;
  private cacheKey: string = 'bannerPositions.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getBannerPosition(id: number): Observable<BannerPosition|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getBannerPositions(parameters: {[param: string]: string | string[]}): Observable<BannerPositionsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addBannerPosition(data: BannerPosition): Observable<BannerPosition|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addBannerPositions(data: BannerPosition[]): Observable<BannerPosition[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateBannerPosition(data: BannerPosition): Observable<BannerPosition|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateBannerPositions(data: BannerPosition[]): Observable<BannerPosition[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchBannerPosition(data: BannerPosition): Observable<BannerPosition|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchBannerPositions(data: BannerPosition[]): Observable<BannerPosition[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteBannerPosition(data: BannerPosition): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteBannerPositions(data: BannerPosition[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((bannerPosition) => {
      ids.push(bannerPosition.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
